import tcNoController from './tc-no.controller';

export default () => {
  return {
    restrict: 'A',
    require: { fieldCtrl: 'ngModel' },
    bindToController: true,
    controller: tcNoController,
    controllerAs: 'tcNoController'
  };
};



// WEBPACK FOOTER //
// src/app/components/tc-no/tc-no.directive.ts